import { render } from "./AccountsSection.vue?vue&type=template&id=f66dec10&scoped=true"
import script from "./AccountsSection.vue?vue&type=script&lang=js"
export * from "./AccountsSection.vue?vue&type=script&lang=js"

import "./AccountsSection.vue?vue&type=style&index=0&id=f66dec10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66dec10"]])

export default __exports__